import { LiaStarSolid } from "react-icons/lia"

function RatingSummary() {
  return (
    <article className="flex flex-row justify-between gap-6 py-8 mb-12 bg-f-bk">
      <div className="flex flex-row justify-between w-full gap-6 mx-6 bg-p-wh shado p-6">
        <div className="w-full text-center flex flex-col justify-center">
          <p className="text-s-bk">Overall rating</p>
          <p className="font-semibold text-2xl">5.0</p>
          <span className="flex flex-row gap-1 pb-4 text-center justify-center">
            <LiaStarSolid className="text-orange-500" />
            <LiaStarSolid className="text-orange-500" />
            <LiaStarSolid className="text-orange-500" />
            <LiaStarSolid className="text-orange-500" />
            <LiaStarSolid className="text-orange-500" />
          </span>
        </div>
        <div className="w-full">
          <div className=" w-full flex flex-row gap-2 items-center ">
            <p className="text-sm text-s-bk">5</p>
            <div className="relative w-full flex flex-row items-center">
              <span className="h-fit py-1 w-full absolute rounded bg-orange-500"></span>
              <span className="h-fit py-1 w-full rounded bg-f-bk "></span>
            </div>
          </div>
          <div className=" w-full flex flex-row gap-2 items-center ">
            <p className="text-sm text-s-bk">4</p>
            <div className="relative w-full flex flex-row items-center">
              <span className="h-fit py-1 w- absolute rounded bg-orange-500"></span>
              <span className="h-fit py-1 w-full rounded bg-f-bk "></span>
            </div>
          </div>
          <div className=" w-full flex flex-row gap-2 items-center ">
            <p className="text-sm text-s-bk">3</p>
            <div className="relative w-full flex flex-row items-center">
              <span className="h-fit py-1 w- absolute rounded bg-orange-500"></span>
              <span className="h-fit py-1 w-full rounded bg-f-bk "></span>
            </div>
          </div>
          <div className=" w-full flex flex-row gap-2 items-center ">
            <p className="text-sm text-s-bk">2</p>
            <div className="relative w-full flex flex-row items-center">
              <span className="h-fit py-1 w- absolute rounded bg-orange-500"></span>
              <span className="h-fit py-1 w-full rounded bg-f-bk "></span>
            </div>
          </div>
          <div className=" w-full flex flex-row gap-2 items-center ">
            <p className="text-sm text-s-bk">1</p>
            <div className="relative w-full flex flex-row items-center">
              <span className="h-fit py-1 w- absolute rounded bg-orange-500"></span>
              <span className="h-fit py-1 w-full rounded bg-f-bk "></span>
            </div>
          </div>
        </div>
        <div className="w-full  text-center">
          <p className="text-s-bk">Based on</p>
          <p className="font-semibold text-2xl">01</p>
          <p className="text-s-bk">ratings</p>
        </div>
      </div>
    </article>
  );
}

export default RatingSummary;
